import Base from './post-base';

export default class extends Base {
  getPage() {
    return 'recognitions-new';
  }
}

